import * as React from "react";
import { withFormsy, IFormsyDecorator } from "formsy-react";

interface Props extends IFormsyDecorator {
  label: string;
  labelBold?: string;
  position: "top" | "left";
}

class Checkbox extends React.Component<Props> {
  render() {
    return (
      <div className="frb frb-successNoC">
        <input
          onChange={this.handleChange}
          type={"checkbox"}
          checked={this.props.getValue()}
          className={this.props.position == "top" ? "frb-top" : ""}
        />
        <label
          onClick={this.labelClick}
          className={
            "text-uppercase" + (this.props.getValue() ? " checked" : "")
          }>
          <span className="frb-title">
            {this.props.labelBold && <b>{this.props.labelBold}</b>}
            {this.props.label}
          </span>
        </label>
      </div>
    );
  }

  labelClick = () => {
    this.props.setValue(!this.props.getValue());
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.setValue(event.currentTarget.checked);
  };
}

export default withFormsy(Checkbox);
